import { InfoBannerStoryblok } from "@/types/sb-component-types";
const InfoBanner = ({
  blok
}: {
  blok: InfoBannerStoryblok;
}) => {
  const visibleFrom = blok.visible_from ? new Date(blok.visible_from) : null;
  const visibleUntil = blok.visible_until ? new Date(blok.visible_until) : null;
  const now = new Date();
  const isVisible = (!visibleFrom || visibleFrom <= now) && (!visibleUntil || now <= visibleUntil);
  if (!isVisible) return null;
  return <div className="sticky top-0 z-50 flex w-full items-center justify-center bg-secondary px-6 py-2.5 sm:px-3.5" data-sentry-component="InfoBanner" data-sentry-source-file="InfoBanner.tsx">
      <p className="text-base leading-6 text-white">{blok.text}</p>
    </div>;
};
export default InfoBanner;